import {
  Palette, Video, PenTool, Target, BarChart3, Layers, Camera, Film,
  Megaphone, Lightbulb, MousePointerClick, Zap, Layout, Code2, TestTube,
  LineChart, Users, Handshake, DollarSign, Shield, Link as LinkIcon,
  Database, ArrowRight, CheckCircle2, Settings, Search, Mail, Globe,
  Monitor, Smartphone, TrendingUp, Activity, Eye, FileText, Clock,
  Cpu, Server, Cloud, Lock, Bookmark, Heart, Star, Award, Flag,
  FlaskConical, FormInput, Workflow, RefreshCw, Send, FileCheck,
  Compass, Wrench, Crosshair, SlidersHorizontal, Gauge, LayoutTemplate,
  Bot, MessageSquare, Code, Brain, Gift, Coins, Trophy, Share2,
  GitBranch, PieChart, MousePointer, Tag, RefreshCcw, MapPin,
  Rocket, Building2, ShoppingBag, Laptop, Sparkles, Home, GraduationCap, Briefcase,
  type LucideIcon,
} from "lucide-react";

const iconMap: Record<string, LucideIcon> = {
  Palette, Video, PenTool, Target, BarChart3, Layers, Camera, Film,
  Megaphone, Lightbulb, MousePointerClick, Zap, Layout, Code2, TestTube,
  LineChart, Users, Handshake, DollarSign, Shield, Link: LinkIcon,
  Database, ArrowRight, CheckCircle2, Settings, Search, Mail, Globe,
  Monitor, Smartphone, TrendingUp, Activity, Eye, FileText, Clock,
  Cpu, Server, Cloud, Lock, Bookmark, Heart, Star, Award, Flag,
  FlaskConical, FormInput, Workflow, RefreshCw, Send, FileCheck,
  Compass, Wrench, Crosshair, SlidersHorizontal, Gauge, LayoutTemplate,
  Bot, MessageSquare, Code, Brain, Gift, Coins, Trophy, Share2,
  GitBranch, PieChart, MousePointer, Tag, RefreshCcw, MapPin,
  Rocket, Building2, ShoppingBag, Laptop, Sparkles, Home, GraduationCap, Briefcase,
};

export const resolveIcon = (name: string): LucideIcon => {
  return iconMap[name] || Target;
};
